import type { IconData } from '@stacksjs/iconify-core'

export const voiceOverRecord: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M342.322 104.837A100.44 100.44 0 0 1 342.457 231l24.943 20.02a132.37 132.37 0 0 0-.178-166.261ZM432.147 32.4l-24.989 20.15a183.6 183.6 0 0 1 .248 230.594l25.03 20.1a216.05 216.05 0 0 0-.289-270.844\"/><path fill=\"currentColor\" d=\"m347.6 343.656l-72.822-47.334l27.455-50.334A80.2 80.2 0 0 0 312 207.681V128a112 112 0 0 0-224 0v79.681a80.24 80.24 0 0 0 9.768 38.308l27.455 50.333L52.4 343.656A79.72 79.72 0 0 0 16 410.732V496h368v-85.268a79.72 79.72 0 0 0-36.4-67.076M352 464H48v-53.268a47.84 47.84 0 0 1 21.841-40.246l97.661-63.48l-41.641-76.34A48.15 48.15 0 0 1 120 207.681V128a80 80 0 0 1 160 0v79.681a48.14 48.14 0 0 1-5.861 22.984L232.5 307.007l97.662 63.479A47.84 47.84 0 0 1 352 410.732Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default voiceOverRecord
